import { MenuItem, MoreHorizMenu } from "designSystem/index";
import React, { FunctionComponent } from "react";
import { useMSTeamsStore } from "./MSTeamsStore";

const ChannelMenu: FunctionComponent = (props) => {
	const { handleRemoveConnectionToChannel, openInMSTeamsApp, userIsReadOnly } = useMSTeamsStore();

	return (
		<MoreHorizMenu>
			<MenuItem onClick={openInMSTeamsApp} res="MSTeamsOpenInApp" />
			{!userIsReadOnly &&
				<MenuItem onClick={handleRemoveConnectionToChannel} res="RemoveConnectionToChannel" />
			}
		</MoreHorizMenu>
	);
};

export default ChannelMenu;